import styled from "styled-components";
import { DefaultCoupon } from "./icon";

interface IProps {
    color?: string;
}
export const DefaultCouponImage = ({ color }: IProps) => (
    <StyledImage color={color}>
        <DefaultCoupon />
    </StyledImage>
);
const StyledImage = styled.div<{ color?: string }>`
    background: ${(p) => p.color || "#676767"};
    width: 100%;
    height: 100%;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
